export const translations = {
  tr: {
    // Navigasyon & Menü
    study: "Çalışma / Sözlük",
    studyShort: "Kelime Kartları",
    morphemes: "Morfemler",
    morphemesTerms: "Morfemler & Terimler",
    games: "Oyunlar",
    gamesStudy: "Oyunlar / Çalışma Alanı",
    progress: "İlerleme",
    myProgress: "İlerlemem (Profil)",
    signInSignUp: "Giriş Yap / Kayıt Ol",
    login: "Giriş Yap",
    register: "Kayıt Ol",
    startFree: "Ücretsiz Başla",
    logout: "Çıkış Yap",
    myProfile: "Profilim",
    home: "Ana Sayfa",
    dashboard: "Panelim",

    // Kategori Etiketleri
    movementSystem: "Hareket Sistemi",
    spineJoints: "Omurga Eklemleri",
    lowerExtremityJoints: "Alt Ekstremite Eklemleri",
    headAndNeckJoints: "Kafa ve Boyun Eklemleri",
    headAndNeckMuscles: "Baş ve Boyun Kasları",
    trunkMuscles: "Gövde Kasları",
    upperExtremityMuscles: "Üst Ekstremite Kasları",
    skullBones: "Kafatası Kemikleri",
    faceBones: "Yüz Kemikleri",
    trunkBones: "Gövde Kemikleri",
    upperExtremityBones: "Üst Ekstremite Kemikleri",
    upperExtremityJoints: "Üst Ekstremite Eklemleri",
    lowerExtremityBones: "Alt Ekstremite Kemikleri",
    movementTerms: "Hareket Terimleri",
    muscleStructures: "Kas ve Kasla İlişkili Yapılar",
    boneStructures: "Kemik / İskelet Yapıları",
    anatomicDirection: "Anatomik Yön Terimleri",
    allCategories: "Tüm Kategoriler",
    categories: "Kategoriler",
    category: "Kategori",
    selectCategory: "Kategori Seçin",
    selectCategoryPlaceholder: "Kategori seç",

    // Study (Sözlük) Sayfası
    searchPlaceholder: "Arama yap...",
    totalTerms: "Toplam Terim",
    medicalTerms: "Tıbbi Terimler",
    terms: "terim",
    termsCount: "terim",
    learned: "Öğrenildi",
    markLearned: "Öğrendim",
    loadingTerms: "Terimler yükleniyor...",
    noTermsFound: "Terim bulunamadı",
    guestMode: "Misafir Modundasınız",
    studyGuestBannerText: "Kelime kartlarını serbestçe inceleyebilir ve 'Öğrendim' işaretlemesi yapabilirsiniz. İlerlemenizi kalıcı tutmak ve tüm cihazlarda senkronize etmek için",
    signUpLink: "Üye Olun",

    // Oyunlar Menüsü
    matchingGame: "Eşleştirme Oyunu",
    morphemeBuilder: "Morfem Yapıcı",
    quizMode: "Quiz Modu",
    flashcards: "Flashcard",
    startGame: "Oyuna Başla",
    play: "Oyna",
    timeScore: "Süre / Skor",
    gamesHeader: "Oyunlar",
    gamesSub: "Farklı oyun modlarıyla tıbbi terminolojiyi kalıcı olarak öğren",
    gameTips: "Oyun İpuçları",
    flashcardDesc: "Terim kartlarını çevirerek öğren. Bildiğin ve bilmediğin terimleri ayır.",
    matchDesc: "Terimleri Türkçe karşılıklarıyla eşleştir. Hızlı düşün, rekor kır!",
    quizDesc: "Çoktan seçmeli sorularla bilgini test et. Kendini sına, ilerlemeyi gör.",
    quizNextQuestion: "Sıradaki Soru",
    morphemeDesc: "Verilen tanıma göre tıbbi terimi ön ek, kök ve son ek seçerek kendin oluştur!",
    guestPlaysRemaining: "3 Günlük Ücretsiz Deneme:",
    guestDaysRemaining: "gün kaldı",
    guestHoursRemaining: "saat kaldı",
    unlimitedPlaySignUp: "Kayıt Ol & Sınırsız Devam Et",
    tip1Title: "🎯 Düzenli Çalış",
    tip1Desc: "Her gün en az 10 dakika çalışarak günlük serileri koruyun ve hızlı öğrenin.",
    tip2Title: "🎮 Çeşitlilik Oluştur",
    tip2Desc: "Farklı oyun modlarını kullanarak bilgilerinizi pekiştirin ve monotonluktan kaçının.",
    tip3Title: "📊 İlerlemeni Takip Et",
    tip3Desc: "Quiz sonuçlarını ve eşleştirme sürelerini takip ederek gelişimini gör.",

    // Oyun İçi Ortak Çeviriler
    error: "Hata",
    backToGames: "Oyunlara Dön",
    loadingCards: "Kartlar Yükleniyor...",
    fetchingTerms: "Kelimeler veritabanından çekiliyor...",
    noTermsInCategory: "Bu kategoriye ait kelime bulunamadı.",
    cardCount: "Kart",
    learnedLabel: "Öğrenilen",
    skippedLabel: "Atlanan",
    term: "Terim",
    clickToFlip: "Kartı çevirmek için tıkla",
    turkishDefinitionLabel: "Türkçe Tanım",
    englishDefinitionLabel: "Tanım / İngilizce Karşılık",
    morphemeStructure: "Morfem Yapısı",
    dontKnow: "Bilmiyorum",
    know: "Biliyorum",
    flipCard: "Kartı Çevir",
    sessionCompleteToast: "Tamamlandı! {learned}/{total} terim öğrenildi.",
    matchSubtitle: "Terimleri Türkçe karşılıklarıyla eşleştir",
    time: "Süre",
    moves: "Hamle",
    matched: "Eşleşme",
    congratulations: "Tebrikler!",
    matchCompleteSub: "Oyunu başarıyla tamamladın!",
    playAgain: "Tekrar Oyna",
    viewGames: "Oyunları Gör",
    matchToast: "Tebrikler! {moves} hamle ve {time} saniyede tamamlandı!",
    matchNoTerms: "Eşleştirme oyunu için kelime havuzu bulunamadı.",
    quizTitle: "Terim Quiz",
    quizQuestion: "Soru",
    quizPromptTerm: "Bu terimin anlamı nedir?",
    quizPromptMeaning: "Bu tanımı karşılayan terim hangisidir?",
    quizCorrect: "Doğru!",
    quizWrong: "Yanlış!",
    quizFinishedTitle: "Quiz Tamamlandı!",
    quizTotalScore: "Toplam Puan",
    quizCorrectLabel: "Doğru",
    quizWrongLabel: "Yanlış",
    quizAccuracy: "Başarı",
    quizPlayAgain: "Yeniden Oyna",
    quizBack: "Geri Dön",
    quizNotEnoughTerms: "Bu kategoride quiz oluşturmak için yeterli terim bulunmuyor.",
    morphemeTargetTerm: "Hedef Terim",
    morphemeBuiltTerm: "Oluşturulan Terim",
    morphemeEmptyHint: "Havuzdan parçaları sırayla seç: Ön Ek → Kök → Son Ek",
    morphemePrefix: "Ön Ek",
    morphemeRoot: "Kök",
    morphemeSuffix: "Son Ek",
    morphemePool: "Parça Havuzu",
    morphemeConfirm: "Kombinasyonu Onayla",
    morphemeCorrectMsg: "Doğru! Harika dizilim.",
    morphemeWrongMsg: "Yanlış kombinasyon. Dizilim sıfırlanıyor, tekrar dene!",
    morphemeFinishedTitle: "Oyun Bitti!",
    morphemeFinalScore: "Toplam Puan",
    morphemePlayAgain: "Yeniden Oyna",
    morphemeNoQuestions: "Bu kategori için soru bulunamadı.",
    morphemeAnalysis: "Morfem Analizi",

    // Dashboard ve İlerleme Paneli
    termsMastered: "Öğrenilen Terimler",
    completionRate: "Tamamlanma Oranı",
    dailyStreak: "Günlük Seri",
    continueLearning: "Kaldığın Yerden Devam Et",
    recentActivity: "Son Aktiviteler",
    hello: "Merhaba",
    welcome: "Hoş geldin",
    averageAccuracy: "Ortalama başarı",
    startTodayReview: "Bugünkü Tekrara Başla",
    selectGame: "Oyun Seç",
    whatToStudyToday: "Bugün Ne Çalışmak İstersin?",
    termOfTheDay: "Bugünün Terimi",
    tapToFlip: "çevirmek için dokun",
    inProgress: "İlerleyen",
    allStats: "Tüm istatistikler",
    progressByRegion: "Bölgeye Göre İlerlemen",
    achievements: "Başarılar",
    history: "Geçmişin",
    quizHistory: "Quiz Geçmişi",
    matchHistory: "Eşleştirme Geçmişi",
    morphemeHistory: "Morfem Geçmişi",
    flashcardHistory: "Flashcard Geçmişi",
    quizLockedForBasicTitle: "Quiz — Pro Planına Özel",
    quizLockedForBasicDesc: "Quiz modu ve ilerleme geçmişi yalnızca Pro ve Ömür Boyu üyelerine açıktır. Temel planda Flashcard ve Eşleştirme geçmişi sınırsız olarak aktiftir.",
    morphemeLockedForBasicTitle: "Morfem Yapıcı — Pro Planına Özel",
    morphemeLockedForBasicDesc: "Morfem Yapıcı oyunu ve ilerleme geçmişi yalnızca Pro ve Ömür Boyu üyelerine açıktır. Temel planda Flashcard ve Eşleştirme geçmişi sınırsız olarak aktiftir.",
    upgradeToPro: "Pro'ya Yükselt",
    daysStreak: "gün",
    dashboardTermsWaiting: "terim seni bekliyor. Serini bozma — 5 dakikanı ayır, kaldığın yerden devam et.",
    dashboardLearnedTermsSub: "terim öğrenildi",
    dashboardAverageScoreSub: "ortalama başarı",
    currentPlace: "Kaldığın yer:",
    termsRemainingWaiting: "terim seni bekliyor.",
    categoryCompleted: "Bu kategoriyi başarıyla tamamladın!",
    latinTerm: "Latin Terim",

    // Progress Sayfası detaylar
    progressSub: "Öğrenme yolculuğun burada — bugün nerede olduğuna ve sıradaki hedefine bakalım.",
    nextGoal: "Sıradaki Hedefin:",
    quizMasterTitle: "Quiz Ustadı",
    quizGoalCompleted: "Tebrikler! Quiz Ustadı hedefine başarıyla ulaştın.",
    quizGoalSub: "5 quiz tamamla — şu an",
    quizzesLeft: "quiz daha kaldı",
    completed: "tamamlandı",
    remainingTerms: "terim daha kaldı",
    wordPool: "kelime havuzunda",
    activity: "Aktivite",
    activeThisMonth: "Bu ay",
    daysActive: "gün aktif",
    longestStreak: "En uzun seri:",
    averageScore: "Ortalama Puan",
    earlyData: "henüz erken",
    steady: "istikrarlı",
    notEnoughData: "Henüz yeterli veri yok. Güvenilir bir ortalama için",
    quizzesToComplete: "quiz daha tamamla.",
    dataCollected: "Yeterli düzeyde veri toplandı. Başarı yüzdeniz kararlı durumda.",
    totalActiveDays: "Toplam Aktif Gün",
    termsReviewed: "terim gözden geçirildi",
    unlocked: "Kilidi Açıldı",
    unlockedAndLocked: "Kilidi açtığın ve henüz ulaşmadığın başarılar",
    achFirstStepTitle: "İlk Adım",
    achFirstStepDesc: "İlk terimi öğren",
    achQuickStartTitle: "Hızlı Başlangıç",
    achQuickStartDesc: "10 terim öğren",
    achStarStudentTitle: "Yıldız Öğrenci",
    achStarStudentDesc: "50 terim öğren",
    achQuizMasterTitle: "Quiz Ustadı",
    achQuizMasterDesc: "5 quiz tamamla",
    achOnFireTitle: "Ateşli",
    achOnFireDesc: "7 günlük seri",
    achPerfectTitle: "Mükemmel",
    achPerfectDesc: "Bir quiz'de %100 al",
    recentQuizzes: "Son Quizler",
    last10QuizPerf: "Son 10 quiz performansın",
    noQuizYet: "Henüz Quiz Çözmedin",
    noQuizSub: "İlk quizini çözdüğünde sonuçların burada listelenecek.",
    solveQuiz: "Quiz Çöz",
    recentMatches: "Son Eşleştirmeler",
    last10MatchPerf: "Son 10 eşleştirme oyunu performansı",
    noMatchYet: "Henüz Eşleştirme Yapmadın",
    noMatchSub: "İlk eşleştirme oyununu oynadığında skorların burada listelenecek.",
    playMatch: "Eşleştirme Oyna",
    recentMorphemes: "Son Morfem Oyunları",
    last10MorphemePerf: "Son 10 Morfem Yapıcı performansın",
    noMorphemeYet: "Henüz Morfem Yapıcı Oynamadın",
    noMorphemeSub: "İlk morfem oyununu oynadığında skorların burada listelenecek.",
    playMorpheme: "Morfem Yapıcı Oyna",
    recentFlashcards: "Son Flashcard Çalışmaları",
    last10FlashcardPerf: "Son 10 flashcard oturumu performansı",
    termsLearnedCount: "terim öğrenildi",
    noFlashcardYet: "Henüz Flashcard Çalışmadın",
    noFlashcardSub: "İlk kartını çevirdiğinde geçmişin burada görünecek.",
    startFlashcards: "Flashcard'a Başla",
    goodStart: "İyi Bir Başlangıç Yaptın!",
    motivationSub: "Eşleştirme ve Morfem Yapıcı'da gerçekten iyi gidiyorsun. Quiz'lerde biraz daha pratik yaparsan Quiz Ustadı rozetine çok yaklaşacaksın.",
    quizMotivationBtn: "Quiz Çöz, Ustalığa Yaklaş",
    studyCardsBtn: "Kelime Kartlarına Çalış",
    guestProgressNotice: "İlerlemeniz bu cihazda geçici olarak tutulmaktadır. İlerlemenizi kaybetmemek ve sınırsız oyun oynamak için üye olun!",
    guestModePreview: "Misafir Modu (Canlı Önizleme)",

    // Landing / Home
    heroBadge: "Sınava Hazırlananlar İçin",
    heroTitle1: "Tıbbi Terimleri",
    heroTitle2: "Ezberlemeden,",
    heroTitle3: "Kalıcı Öğren",
    heroDesc: "Kök, önek ve sonekleri oyunlaştırılmış kartlarla pekiştir. Sınav öncesi hızlı tekrar için tasarlandı — kayıt olmadan hemen dene.",
    tryWithoutRegister: "Kayıt olmadan dene",
    showNotTellTitle: "Anlatmak yerine",
    showNotTellSub: "gösteriyoruz",
    tryWithoutRegisterHeader: "Kayıt Olmadan Dene",

    // Profilim Sayfası & Ayarlar
    appLanguage: "Uygulama Dili / Interface Language",
    language: "Uygulama Dili",
    interfaceLanguage: "Uygulama Dili",
    interfaceLanguageSub: "Platformun tercih edilen arayüz dili",
    turkish: "Türkçe",
    english: "English",
    myAccount: "Hesabım",
    myProfile: "Profilim",
    profileSubtitle: "Kimlik bilgilerin ve hesap ayarların burada.",
    membership: "Üyelik:",
    accountSettings: "Hesap Ayarları",
    accountSettingsSub: "Bildirimler, güvenlik, dil ve veri tercihlerin.",
    edit: "Düzenle",
    close: "Kapat",
    saveChanges: "Değişiklikleri Kaydet",
    saving: "Kaydediliyor...",
    cancel: "Vazgeç",
    fullName: "Ad Soyad",
    email: "E-posta",
    password: "Şifre",
    emailCannotBeChanged: "E-posta adresi değiştirilemez.",
    profileUpdated: "Profil başarıyla güncellendi!",
    profileUpdateError: "Profil güncellenirken bir sorun oluştu.",
    nameRequired: "İsim alanı boş bırakılamaz.",
    statusStripStreakText: "seri · detaylı analiz ve rozetler için",
    progressPageLink: "İlerleme Sayfası →",
    guestFlashcardDailyLimitTitle: "Günlük Ücretsiz Kelime Kartı Hakkınız Doldu! 🎯",
    guestFlashcardDailyLimitDesc: "Misafir kullanıcılar günde en fazla 5 kelime kartı çalışması yapabilir. Sınırsız pratik yapmak ve ilerlemenizi kaydetmek için lütfen ücretsiz üye olun.",
    guestMatchLockedTitle: "Eşleştirme Oyunu Kayıtlı Kullanıcılara Özeldir! 🎯",
    guestMatchLockedDesc: "Eşleştirme oyunu yalnızca kayıtlı üyelere açıktır. Terimleri eşleştirerek pratik yapmak ve skorlarınızı kaydetmek için lütfen ücretsiz kayıt olun.",
    guestMatchCardTitle: "Ücretsiz Üye Olun & Eşleştirmeye Başlayın",
    guestMatchCardDesc: "Ücretsiz üyelik oluşturarak Eşleştirme ve Flashcard oyunlarına sınırsız erişebilir, ilerlemenizi tüm cihazlarınızda takip edebilirsiniz.",
    accountRequired: "Temel",
    registerToPlay: "Temel ve Üzeri ile Aç",
    unlockWithBasic: "Temel ve Üzeri ile Aç",
    matchExclusiveToBasic: "Eşleştirme oyunu Temel ve üzeri planlara özeldir. Flashcard oyunu misafir kullanımına açıktır.",
    showcaseBadges: "Vitrin Rozetlerin",
    showcaseSub: "Profilinde öne çıkacak en fazla 3 rozet seç. Kazanılan rozetlerin üzerine tıklayarak vitrine ekleyebilir veya kaldırabilirsin.",
    maxBadgesWarning: "En fazla 3 adet rozet vitrine ekleyebilirsiniz.",
    viewAll: "Tümünü Gör →",
    emailNotificationsTitle: "E-posta bildirimleri",
    emailNotificationsSub: "Haftalık ilerleme özeti ve yeni özellik duyuruları",
    changePassword: "Şifreyi değiştir",
    changePasswordSub: "Kayıtlı e-postanıza şifre sıfırlama linki gönderilir",
    change: "Değiştir",
    resetEmailSent: "Şifre sıfırlama e-postası gönderildi!",
    resetEmailError: "Şifre sıfırlama e-postası gönderilemedi.",
    downloadData: "Verilerimi indir",
    downloadDataSub: "Tüm öğrenme geçmişini JSON olarak dışa aktar",
    download: "İndir",
    dataDownloaded: "Verileriniz JSON olarak indirildi.",
    dangerZone: "Tehlikeli Bölge",
    dangerZoneSub: "Bu işlemler geri alınamaz.",
    deleteAccount: "Hesabımı sil",
    deleteAccountSub: "Tüm ilerlemen ve verilerin kalıcı olarak silinir",
    deleteAccountBtn: "Hesabı Sil",
    deleteAccountConfirm: "Hesabınızı silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
    accountDeleted: "Hesabınız kalıcı olarak silindi.",
    deleteAccountRelogin: "Güvenlik nedeniyle, hesabınızı silmeden önce çıkış yapıp tekrar giriş yapmanız gerekmektedir.",
    badgeFirstStep: "İlk Adım",
    badgeQuickStart: "Hızlı Başlangıç",
    badgeQuizMaster: "Quiz Ustadı",
    badgeOnFire: "Ateşli",
    loggedOut: "Çıkış yapıldı",

    // Auth & Giriş / Kayıt
    loginTitle: "HealthLexMed'e Giriş Yap",
    loginSubtitle: "Hesabınıza erişin ve öğrenmeye devam edin",
    fillAllFields: "Lütfen tüm alanları doldurun",
    loginSuccess: "Giriş başarılı! Hoş geldiniz.",
    noAccount: "Hesabın yok mu?",
    signUp: "Kayıt Ol",
    registerTitle: "HealthLexMed'e Kayıt Ol",
    registerSubtitle: "Ücretsiz hesap oluştur ve öğrenmeye başla",
    registerSuccess: "Hesap oluşturuldu! Hoş geldiniz.",
    alreadyHaveAccount: "Zaten hesabın var mı?",
    creatingAccount: "Hesap Oluşturuluyor...",
    createAccount: "Hesap Oluştur",
    fullNamePlaceholder: "Adınız Soyadınız",
    passwordPlaceholder: "En az 6 karakter",

    // GuestLimitModal
    guestLimitTitle: "3 Günlük Ücretsiz Deneme Süreniz Sona Erdi! 🎯",
    guestLimitDesc: "Tüm platform içeriklerini ve oyunları keşfetmeniz için sunulan deneme süreniz veya günlük hakkınız tamamlandı. Sınırsız pratik yapmak için lütfen planınızı yükseltin.",
    guestLimitCardTitle: "Ücretsiz Üye Olun",
    guestLimitCardDesc: "Kayıt olarak ilerlemenizi senkronize edebilir ve platform özelliklerinden faydalanabilirsiniz.",
    upgradePlanCardTitle: "Planınızı Yükseltin",
    upgradePlanCardDesc: "Temel veya Pro plana geçerek tüm kelime kartlarına ve oyunlara sınırsız erişebilirsiniz.",
    upgradePlanBtn: "Planınızı Yükseltin",
    signUpFree: "Ücretsiz Üye Ol",
    signUpUnlimited: "Ücretsiz Üye Ol",
    alreadyHaveAccountLogin: "Zaten Hesabım Var, Giriş Yap",
    backToGamesPage: "Oyunlar Sayfasına Dön",
    userFlashcardDailyLimitDesc: "Günlük kelime kartı çalışma hakkınız doldu. Sınırsız pratik yapmak ve tüm içeriklere erişmek için lütfen planınızı yükseltin.",
    userFlashcardRestartLimitDesc: "Günlük yeniden başlatma hakkınız doldu. Sınırsız pratik yapmak için lütfen planınızı yükseltin.",

    // İletişim & Destek (Contact)
    contactSupport: "İletişim & Destek",
    contactSupportDesc: "Sorularınız, teknik destek talepleriniz veya geri bildirimleriniz için bize dilediğiniz zaman ulaşabilirsiniz.",
    supportEmail: "help@healthlexmed.com",
    contactSlaNotice: "Taleplerinize 24-48 saat içinde dönüş sağlanır.",
    termsOfService: "Kullanım Koşulları",
    privacyPolicy: "Gizlilik Politikası",
    refundPolicy: "İptal & İade Politikası",
    copyEmail: "Adresi Kopyala",
    emailCopied: "E-posta adresi panoya kopyalandı!",
    openEmailApp: "E-posta Uygulamasında Aç",
    formPaddleNotice: "Mesajı gönderdiğinizde varsayılan e-posta istemciniz help@healthlexmed.com alıcısıyla açılır. Talebinize 24-48 saat içinde dönüş sağlanır.",

    // Kayıt ve Çerez Tercihleri
    acceptTermsPrefix: "",
    acceptTermsSuffix: "'nı okudum, anladım ve kabul ediyorum.",
    mustAcceptTerms: "Kayıt olabilmek için lütfen Kullanım Koşulları, Gizlilik ve İptal Politikalarını kabul edin.",
    cookieBannerTitle: "Çerez tercihleri",
    cookieBannerDesc: "Deneyimini iyileştirmek ve reklam performansını ölçmek için zorunlu, analitik ve pazarlama çerezleri kullanıyoruz.",
    cookieDetails: " ",
    cookieBannerDescPart1: "Platformumuzda oturumunuzu sürdürmek, dil tercihlerinizi hatırlamak ve deneyiminizi geliştirmek amacıyla çerezler kullanıyoruz. Detaylı bilgi için ",
    cookiePolicyLinkText: "Çerez Politikası",
    cookieBannerDescPart2: " inceleyebilirsiniz.",
    cookieCategoryNecessary: "Zorunlu",
    cookieCategoryNecessaryDesc: "Giriş, dil tercihi ve güvenlik gibi sitenin çalışması için gereken çerezler.",
    cookieBadgeAlwaysOn: "Her zaman açık",
    cookieCategoryAnalytics: "Analitik",
    cookieCategoryAnalyticsDesc: "Hangi sayfaların ve özelliklerin kullanıldığını anlamamıza yardımcı olur (Google Analytics, PostHog).",
    cookieCategoryMarketing: "Pazarlama",
    cookieCategoryMarketingDesc: "Reklamlarımızın sonuçlarını ölçmemize ve ilgilenebilecek kişilere ulaşmamıza yardımcı olur (Meta Pikseli).",
    cookieAccept: "Tümünü kabul et",
    cookieDecline: "Yalnızca zorunlu",
    cookieManage: "Tercihleri yönet",
    cookieSave: "Seçimi kaydet",
    cookieBack: "Geri",
    cookiePreferences: "Çerez tercihleri",
  },
  en: {
    // Navigasyon & Menü
    study: "Study & Dictionary",
    studyShort: "Study Cards",
    morphemes: "Morphemes",
    morphemesTerms: "Morphemes & Terms",
    games: "Games",
    gamesStudy: "Games / Practice",
    progress: "Progress",
    myProgress: "My Progress (Profile)",
    signInSignUp: "Sign In / Sign Up",
    login: "Sign In",
    register: "Sign Up",
    startFree: "Start Free",
    logout: "Log Out",
    myProfile: "My Profile",
    home: "Home",
    dashboard: "Dashboard",

    // Kategori Etiketleri
    movementSystem: "Movement System",
    spineJoints: "Spine Joints",
    lowerExtremityJoints: "Lower Extremity Joints",
    headAndNeckJoints: "Head and Neck Joints",
    headAndNeckMuscles: "Head and Neck Muscles",
    trunkMuscles: "Trunk Muscles",
    upperExtremityMuscles: "Upper Extremity Muscles",
    skullBones: "Skull Bones",
    faceBones: "Face Bones",
    trunkBones: "Trunk Bones",
    upperExtremityBones: "Upper Extremity Bones",
    upperExtremityJoints: "Upper Extremity Joints",
    lowerExtremityBones: "Lower Extremity Bones",
    movementTerms: "Movement Terms",
    muscleStructures: "Muscle and Related Structures",
    boneStructures: "Bone / Skeletal Structures",
    anatomicDirection: "Anatomical Directional Terms",
    allCategories: "All Categories",
    categories: "Categories",
    category: "Category",
    selectCategory: "Select Category",
    selectCategoryPlaceholder: "Select category",

    // Study (Sözlük) Sayfası
    searchPlaceholder: "Search terms...",
    totalTerms: "Total Terms",
    medicalTerms: "Medical Terms",
    terms: "terms",
    termsCount: "terms",
    learned: "Learned",
    markLearned: "Mark as Learned",
    loadingTerms: "Loading terms...",
    noTermsFound: "No terms found",
    guestMode: "You are in Guest Mode",
    studyGuestBannerText: "You can freely review flashcards and mark them as learned. To keep your progress permanent and sync across devices,",
    signUpLink: "Sign Up",

    // Oyunlar Menüsü
    matchingGame: "Matching Game",
    morphemeBuilder: "Morpheme Builder",
    quizMode: "Quiz Mode",
    flashcards: "Flashcard",
    startGame: "Start Game",
    play: "Play",
    timeScore: "Time / Score",
    gamesHeader: "Games",
    gamesSub: "Learn medical terminology permanently with different game modes",
    gameTips: "Game Tips",
    flashcardDesc: "Learn by flipping term cards. Separate known and unknown terms.",
    matchDesc: "Match terms with their meanings. Think fast, break records!",
    quizDesc: "Test your knowledge with multiple choice questions. Challenge yourself, see progress.",
    quizNextQuestion: "Next Question",
    morphemeDesc: "Build the medical term yourself by selecting prefix, root and suffix!",
    guestPlaysRemaining: "3-Day Free Trial:",
    guestDaysRemaining: "days left",
    guestHoursRemaining: "hours left",
    unlimitedPlaySignUp: "Sign Up & Continue Unlimited",
    tip1Title: "🎯 Practice Regularly",
    tip1Desc: "Maintain your daily streak and learn faster by practicing at least 10 minutes every day.",
    tip2Title: "🎮 Create Variety",
    tip2Desc: "Reinforce your knowledge and avoid monotony by using different game modes.",
    tip3Title: "📊 Track Your Progress",
    tip3Desc: "Track your quiz results and matching times to see your progress.",

    // Oyun İçi Ortak Çeviriler
    error: "Error",
    backToGames: "Back to Games",
    loadingCards: "Loading Cards...",
    fetchingTerms: "Fetching terms from database...",
    noTermsInCategory: "No terms found for this category.",
    cardCount: "Card",
    learnedLabel: "Learned",
    skippedLabel: "Skipped",
    term: "Term",
    clickToFlip: "Click to flip card",
    turkishDefinitionLabel: "Turkish Definition",
    englishDefinitionLabel: "Definition / English Meaning",
    morphemeStructure: "Morpheme Breakdown",
    dontKnow: "Don't Know",
    know: "I Know",
    flipCard: "Flip Card",
    sessionCompleteToast: "Completed! {learned}/{total} terms learned.",
    matchSubtitle: "Match Latin terms with their English names",
    time: "Time",
    moves: "Moves",
    matched: "Matched",
    congratulations: "Congratulations!",
    matchCompleteSub: "You successfully completed the game!",
    playAgain: "Play Again",
    viewGames: "View Games",
    matchToast: "Congratulations! Completed in {moves} moves and {time} seconds!",
    matchNoTerms: "Word pool for matching game not found.",
    quizTitle: "Term Quiz",
    quizQuestion: "Question",
    quizPromptTerm: "What does this term mean?",
    quizPromptMeaning: "Which term matches this definition?",
    quizCorrect: "Correct!",
    quizWrong: "Wrong!",
    quizFinishedTitle: "Quiz Completed!",
    quizTotalScore: "Total Score",
    quizCorrectLabel: "Correct",
    quizWrongLabel: "Wrong",
    quizAccuracy: "Accuracy",
    quizPlayAgain: "Play Again",
    quizBack: "Go Back",
    quizNotEnoughTerms: "Not enough terms in this category to build a quiz.",
    morphemeTargetTerm: "Target Term",
    morphemeBuiltTerm: "Constructed Term",
    morphemeEmptyHint: "Select parts from the pool in order: Prefix → Root → Suffix",
    morphemePrefix: "Prefix",
    morphemeRoot: "Root",
    morphemeSuffix: "Suffix",
    morphemePool: "Part Pool",
    morphemeConfirm: "Confirm Combination",
    morphemeCorrectMsg: "Correct! Great sequence.",
    morphemeWrongMsg: "Wrong combination. Sequence reset — try again!",
    morphemeFinishedTitle: "Game Over!",
    morphemeFinalScore: "Final Score",
    morphemePlayAgain: "Play Again",
    morphemeNoQuestions: "No questions found for this category.",
    morphemeAnalysis: "Morpheme Analysis",

    // Dashboard ve İlerleme Paneli
    termsMastered: "Terms Mastered",
    completionRate: "Completion Rate",
    dailyStreak: "Daily Streak",
    continueLearning: "Continue Learning",
    recentActivity: "Recent Activity",
    hello: "Hello",
    welcome: "Welcome",
    averageAccuracy: "Average accuracy",
    startTodayReview: "Start Today's Review",
    selectGame: "Select Game",
    whatToStudyToday: "What Would You Like to Study Today?",
    termOfTheDay: "Term of the Day",
    tapToFlip: "tap to flip",
    inProgress: "In Progress",
    allStats: "All statistics",
    progressByRegion: "Progress by Region",
    achievements: "Achievements",
    history: "Your History",
    quizHistory: "Quiz History",
    matchHistory: "Matching History",
    morphemeHistory: "Morpheme History",
    flashcardHistory: "Flashcard History",
    quizLockedForBasicTitle: "Quiz — Exclusive to Pro Plan",
    quizLockedForBasicDesc: "Quiz mode and progress history are only available to Pro and Lifetime members. In the Basic plan, Flashcard and Matching history are active.",
    morphemeLockedForBasicTitle: "Morpheme Builder — Exclusive to Pro Plan",
    morphemeLockedForBasicDesc: "Morpheme Builder game and progress history are only available to Pro and Lifetime members. In the Basic plan, Flashcard and Matching history are active.",
    upgradeToPro: "Upgrade to Pro",
    daysStreak: "days",
    dashboardTermsWaiting: "terms waiting for you today. Keep your streak — spend 5 minutes and pick up where you left off.",
    dashboardLearnedTermsSub: "terms learned",
    dashboardAverageScoreSub: "average accuracy",
    currentPlace: "Current progress:",
    termsRemainingWaiting: "terms waiting for you.",
    categoryCompleted: "You have successfully completed this category!",
    latinTerm: "Latin Term",

    // Progress Sayfası detaylar
    progressSub: "Your learning journey is here — let's check where you are today and your next goal.",
    nextGoal: "Your Next Goal:",
    quizMasterTitle: "Quiz Master",
    quizGoalCompleted: "Congratulations! You have successfully reached the Quiz Master goal.",
    quizGoalSub: "Complete 5 quizzes — currently at",
    quizzesLeft: "more quizzes left",
    completed: "completed",
    remainingTerms: "terms remaining",
    wordPool: "in the word pool",
    activity: "Activity",
    activeThisMonth: "This month",
    daysActive: "days active",
    longestStreak: "Longest streak:",
    averageScore: "Average Score",
    earlyData: "early stage",
    steady: "consistent",
    notEnoughData: "Not enough data yet. Complete",
    quizzesToComplete: "more quizzes for a reliable average.",
    dataCollected: "Sufficient data collected. Your accuracy percentage is steady.",
    totalActiveDays: "Total Active Days",
    termsReviewed: "terms reviewed",
    unlocked: "Unlocked",
    unlockedAndLocked: "Achievements you have unlocked and those yet to be reached",
    achFirstStepTitle: "First Step",
    achFirstStepDesc: "Learn your first term",
    achQuickStartTitle: "Quick Start",
    achQuickStartDesc: "Learn 10 terms",
    achStarStudentTitle: "Star Student",
    achStarStudentDesc: "Learn 50 terms",
    achQuizMasterTitle: "Quiz Master",
    achQuizMasterDesc: "Complete 5 quizzes",
    achOnFireTitle: "On Fire",
    achOnFireDesc: "7-day streak",
    achPerfectTitle: "Perfect Score",
    achPerfectDesc: "Score 100% in a quiz",
    recentQuizzes: "Recent Quizzes",
    last10QuizPerf: "Your last 10 quiz performances",
    noQuizYet: "You Haven't Solved Any Quizzes Yet",
    noQuizSub: "When you solve your first quiz, your results will be listed here.",
    solveQuiz: "Solve Quiz",
    recentMatches: "Recent Matches",
    last10MatchPerf: "Your last 10 matching game performances",
    noMatchYet: "You Haven't Played Matching Yet",
    noMatchSub: "When you play your first matching game, your scores will be listed here.",
    playMatch: "Play Matching",
    recentMorphemes: "Recent Morpheme Games",
    last10MorphemePerf: "Your last 10 Morpheme Builder performances",
    noMorphemeYet: "You Haven't Played Morpheme Builder Yet",
    noMorphemeSub: "When you play your first morpheme game, your scores will be listed here.",
    playMorpheme: "Play Morpheme Builder",
    recentFlashcards: "Recent Flashcard Sessions",
    last10FlashcardPerf: "Your last 10 flashcard sessions performance",
    termsLearnedCount: "terms learned",
    noFlashcardYet: "You Haven't Studied Flashcards Yet",
    noFlashcardSub: "When you flip your first card, your history will appear here.",
    startFlashcards: "Start Flashcards",
    goodStart: "You Made a Great Start!",
    motivationSub: "You are doing really well in Matching and Morpheme Builder. Practice a bit more in Quizzes to get close to the Quiz Master badge.",
    quizMotivationBtn: "Solve Quizzes, Get Closer to Mastery",
    studyCardsBtn: "Study Flashcards",
    guestProgressNotice: "Your progress is saved temporarily on this device. Sign up to save your progress permanently and enjoy unlimited play!",
    guestModePreview: "Guest Mode (Live Preview)",

    // Landing / Home
    heroBadge: "For Exam Preparation",
    heroTitle1: "Learn Medical Terms",
    heroTitle2: "Without Memorizing,",
    heroTitle3: "Permanently",
    heroDesc: "Master roots, prefixes, and suffixes with gamified flashcards. Designed for quick exam review — try now without registering.",
    tryWithoutRegister: "Try without registering",
    showNotTellTitle: "Instead of telling,",
    showNotTellSub: "we show you",
    tryWithoutRegisterHeader: "Try Without Registering",

    // Profilim Sayfası & Ayarlar
    appLanguage: "Interface Language / Uygulama Dili",
    language: "Interface Language",
    interfaceLanguage: "Interface Language",
    interfaceLanguageSub: "Preferred interface language of the platform",
    turkish: "Turkish",
    english: "English",
    myAccount: "My Account",
    myProfile: "My Profile",
    profileSubtitle: "Your account information and settings are here.",
    membership: "Member since:",
    accountSettings: "Account Settings",
    accountSettingsSub: "Notifications, security, language and data preferences.",
    edit: "Edit",
    close: "Close",
    saveChanges: "Save Changes",
    saving: "Saving...",
    cancel: "Cancel",
    fullName: "Full Name",
    email: "Email",
    password: "Password",
    emailCannotBeChanged: "Email address cannot be changed.",
    profileUpdated: "Profile updated successfully!",
    profileUpdateError: "An error occurred while updating profile.",
    nameRequired: "Name field cannot be empty.",
    statusStripStreakText: "streak · for detailed analysis and badges",
    progressPageLink: "Progress Page →",
    guestFlashcardDailyLimitTitle: "Daily Free Flashcards Limit Reached! 🎯",
    guestFlashcardDailyLimitDesc: "Guests can perform up to 5 flashcard study sessions daily. Please sign up for free for unlimited practice and to save your progress.",
    guestMatchLockedTitle: "Matching Game Requires a Free Account! 🎯",
    guestMatchLockedDesc: "The matching game is exclusively available to registered members. Create a free account to test your skills and save your progress.",
    guestMatchCardTitle: "Create a Free Account & Play Unlimited",
    guestMatchCardDesc: "By creating a free account, you unlock unlimited Matching and Flashcard games and track your personal progress.",
    accountRequired: "Basic",
    registerToPlay: "Unlock with Basic & Above",
    unlockWithBasic: "Unlock with Basic & Above",
    matchExclusiveToBasic: "Matching game is exclusive to Basic and above plans. Flashcards are available in guest mode.",
    showcaseBadges: "Showcase Badges",
    showcaseSub: "Select up to 3 badges to feature on your profile. Click any unlocked badge to pin or unpin it.",
    maxBadgesWarning: "You can pin a maximum of 3 badges.",
    viewAll: "View All →",
    emailNotificationsTitle: "Email notifications",
    emailNotificationsSub: "Weekly progress summary and new feature announcements",
    changePassword: "Change password",
    changePasswordSub: "A password reset link will be sent to your registered email",
    change: "Change",
    resetEmailSent: "Password reset email sent!",
    resetEmailError: "Could not send password reset email.",
    downloadData: "Download my data",
    downloadDataSub: "Export all learning history as JSON",
    download: "Download",
    dataDownloaded: "Your data has been downloaded as JSON.",
    dangerZone: "Danger Zone",
    dangerZoneSub: "These actions cannot be undone.",
    deleteAccount: "Delete account",
    deleteAccountSub: "All your progress and data will be permanently deleted",
    deleteAccountBtn: "Delete Account",
    deleteAccountConfirm: "Are you sure you want to delete your account? This action cannot be undone.",
    accountDeleted: "Your account has been permanently deleted.",
    deleteAccountRelogin: "For security reasons, please log out and log in again before deleting your account.",
    badgeFirstStep: "First Step",
    badgeQuickStart: "Quick Start",
    badgeQuizMaster: "Quiz Master",
    badgeOnFire: "On Fire",
    loggedOut: "Logged out successfully",

    // Auth & Giriş / Kayıt
    loginTitle: "Log In to HealthLexMed",
    loginSubtitle: "Access your account and continue learning",
    fillAllFields: "Please fill in all fields",
    loginSuccess: "Login successful! Welcome back.",
    noAccount: "Don't have an account?",
    signUp: "Sign Up",
    registerTitle: "Sign Up for HealthLexMed",
    registerSubtitle: "Create a free account and start learning",
    registerSuccess: "Account created! Welcome.",
    alreadyHaveAccount: "Already have an account?",
    creatingAccount: "Creating Account...",
    createAccount: "Create Account",
    fullNamePlaceholder: "Your Full Name",
    passwordPlaceholder: "At least 6 characters",

    // GuestLimitModal
    guestLimitTitle: "Your 3-Day Free Trial Has Ended! 🎯",
    guestLimitDesc: "Your trial period or daily limit to explore platform content and games has ended. Please upgrade your plan for unlimited practice.",
    guestLimitCardTitle: "Sign Up Free",
    guestLimitCardDesc: "Create an account to sync your progress and access platform features.",
    upgradePlanCardTitle: "Upgrade Your Plan",
    upgradePlanCardDesc: "Upgrade to Basic or Pro to get unlimited access to all flashcards and games.",
    upgradePlanBtn: "Upgrade Plan",
    signUpFree: "Sign Up Free",
    signUpUnlimited: "Sign Up Free",
    alreadyHaveAccountLogin: "Already have an account, Log In",
    backToGamesPage: "Back to Games Page",
    userFlashcardDailyLimitDesc: "Your daily flashcard limit has been reached. Please upgrade your plan to practice without limits.",
    userFlashcardRestartLimitDesc: "Your daily restart limit has been reached. Please upgrade your plan to practice without limits.",

    // Contact & Support
    contactSupport: "Contact & Support",
    contactSupportDesc: "Feel free to reach out to us anytime for questions, technical support, billing, or feedback.",
    supportEmail: "help@healthlexmed.com",
    contactSlaNotice: "Requests are replied within 24-48 hours.",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    refundPolicy: "Refund Policy",
    copyEmail: "Copy Email",
    emailCopied: "Email address copied to clipboard!",
    openEmailApp: "Open in Email App",
    formPaddleNotice: "Submitting this form opens your default email client addressed to help@healthlexmed.com. You will receive a response within 24-48 hours.",

    // Registration and Cookie Preferences
    acceptTermsPrefix: "I have read, understood, and accept the ",
    acceptTermsSuffix: ".",
    mustAcceptTerms: "Please accept the Terms of Service, Privacy Policy, and Refund Policy to register.",
    cookieBannerTitle: "Cookie preferences",
    cookieBannerDesc: "We use essential, analytics, and marketing cookies to improve your experience and measure ad performance.",
    cookieDetails: " ",
    cookieBannerDescPart1: "We use cookies to maintain your secure session, remember your language preferences, and optimize your learning experience. You can learn more by reviewing our ",
    cookiePolicyLinkText: "Cookie Policy",
    cookieBannerDescPart2: ".",
    cookieCategoryNecessary: "Essential",
    cookieCategoryNecessaryDesc: "Cookies needed for the site to work, such as sign-in, language and security.",
    cookieBadgeAlwaysOn: "Always on",
    cookieCategoryAnalytics: "Analytics",
    cookieCategoryAnalyticsDesc: "Help us understand which pages and features are used (Google Analytics, PostHog).",
    cookieCategoryMarketing: "Marketing",
    cookieCategoryMarketingDesc: "Help us measure our ads and reach people who may be interested (Meta Pixel).",
    cookieAccept: "Accept all",
    cookieDecline: "Essential only",
    cookieManage: "Manage preferences",
    cookieSave: "Save choices",
    cookieBack: "Back",
    cookiePreferences: "Cookie preferences",
  }
};
